module.exports = __webpack_public_path__ + "static/media/保腎護心網layout物件_53.5a3f393d.png";